export const width=1200;export const height=630;export default{width:width,height:height};